import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { SessionProvider } from "./auth/SessionProvider";
import { clearLegacyAuth0Storage } from "./auth/session";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

/*
 * `patreon-direct-auth` task 9: `Auth0Provider` is gone, and with it three
 * things that were load-bearing under Auth0 and are now simply absent.
 *
 * - **`cacheLocation="localstorage"`.** The token lived in `localStorage`
 *   because the in-memory default did not survive a reload and recovery meant
 *   a hidden iframe against the tenant domain, which Chrome blocks. It was
 *   accepted knowing any injected script could read it. The session is now an
 *   `httpOnly` cookie: it survives a reload because the browser keeps it, and
 *   no script on this page can read it at all.
 * - **`useRefreshTokens`.** Same problem, same iframe. Our cookie lasts a week
 *   and the server holds the Patreon refresh token, so the browser has nothing
 *   to renew.
 * - **`onRedirectCallback`.** Auth0 came back with `?code=` and `&state=` in
 *   the address bar and they had to be scrubbed, or a refresh replayed a
 *   consumed authorization code as a failed login. Our callback lands on the
 *   API, not here; the browser is redirected to a clean URL with the session
 *   already set. There is nothing to tidy.
 *
 * The deep-link `returnTo` (FR-2) moved with it. It rides inside the signed
 * state cookie now and the server re-validates it before redirecting, so it is
 * never in a URL a third party could hand someone.
 */
/*
 * Before anything renders. Removing the provider that wrote tokens to
 * `localStorage` does not remove the tokens it already wrote, and they stay
 * valid until they expire.
 */
clearLegacyAuth0Storage();

root.render(
  <SessionProvider>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </SessionProvider>
);
